function toIdSafe(value) {
    return String(value || '').replace(/[^a-z0-9]/gi, '_');
}

function getConfig(el) {
    const breakpoint = el.getAttribute('breakpoint') || el.getAttribute('media') || '(max-width: 39.9375em)';
    const type = el.getAttribute('type') || 'media';
    const id = `ts_${type.slice(0, 1)}${toIdSafe(breakpoint)}`;
    return {breakpoint, type, id};
}

function getLabels(el) {
    const headerCells = el.querySelectorAll('thead th');
    if (!headerCells.length) return [];

    const labels = Array.from(headerCells).map((cell, index) => {
        if (index === 0) {
            const weight = window.getComputedStyle(cell).getPropertyValue('font-weight');
            if (weight) {
                el.style.setProperty('--table-saw-header-bold', weight);
            }
        }
        const text = (cell.innerText || cell.textContent || '').trim();
        return text;
    });

    return labels;
}

function applyRatio(el) {
    const ratio = el.getAttribute('ratio');
    if (!ratio) return;
    const ratioString = ratio.split('/').join('fr ') + 'fr';
    el.style.setProperty('--table-saw-ratio', ratioString);
}

function applyTextAlign(el) {
    if (!el.hasAttribute('text-align')) return;
    const value = el.getAttribute('text-align') || 'left';
    el.style.setProperty('--table-saw-text-align', value);
}

function wrapComplexCell(cell) {
    let nodeCount = 0;
    for (const n of cell.childNodes) {
        if (n.nodeType === 3 || n.nodeType === 1) nodeCount++;
    }
    if (nodeCount <= 1) return;
    if (cell.querySelector(':scope > .tablesaw-wrap')) return;

    const wrapper = document.createElement('div');
    wrapper.classList.add('tablesaw-wrap');
    while (cell.firstChild) {
        wrapper.appendChild(cell.firstChild);
    }
    cell.appendChild(wrapper);
}

function applyLabels(el, labels) {
    const cells = el.querySelectorAll('tbody :is(td, th)');
    for (const cell of cells) {
        if (!labels[cell.cellIndex]) continue;
        cell.setAttribute('data-tablesaw-label', labels[cell.cellIndex]);
        wrapComplexCell(cell);
    }
}

function ensureStyles({breakpoint, type, id}) {
    if (document.head.querySelector(`style[data-table-saw-id="${id}"]`)) return;

    const ruleAt = type === 'container' ? '@container' : '@media';
    const style = document.createElement('style');
    style.setAttribute('data-table-saw-id', id);
    style.textContent = `
table-saw.${id} {
    display: block;
    ${type === 'container' ? 'container-type: inline-size;' : ''}
}
${ruleAt} ${breakpoint} {
    table-saw.${id} thead :is(th, td) {
        position: absolute;
        height: 1px;
        width: 1px;
        overflow: hidden;
        clip: rect(1px, 1px, 1px, 1px);
    }
    table-saw.${id} :is(tbody, tfoot) tr {
        display: block;
    }
    table-saw.${id} :is(tbody, tfoot) :is(th, td):before {
        content: attr(data-tablesaw-label);
        font-weight: var(--table-saw-header-bold);
    }
    table-saw.${id} :is(tbody, tfoot) :is(th, td) {
        display: grid;
        gap: 0 1em;
        grid-template-columns: var(--table-saw-ratio, 1fr 2fr);
    }
    table-saw.${id}[text-align] :is(tbody, tfoot) :is(th, td) {
        text-align: var(--table-saw-text-align, left);
    }
    table-saw.${id}[zero-padding] :is(tbody, tfoot) :is(th, td) {
        padding-left: 0;
        padding-right: 0;
    }
}`;
    document.head.appendChild(style);
}

function initTableSawFallback() {
    const tableSawEls = document.querySelectorAll('table-saw.text__table');
    tableSawEls.forEach((el) => {
        const labels = getLabels(el);
        if (!labels.length) return;

        applyRatio(el);
        applyTextAlign(el);
        applyLabels(el, labels);

        const config = getConfig(el);
        el.classList.add(config.id);
        ensureStyles(config);
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTableSawFallback, {once: true});
} else {
    initTableSawFallback();
}
